import { LoadingLabelFrame } from "@/overlay/components/QuickAccessLabel/LoadingLabelFrame";
import styles from "@/overlay/components/QuickAccessLabel/QuickAccessLabel.module.scss";
import { useOverlay } from "@/overlay/overlays/default/ViewportOverlayProvider";
import { classNames } from "@/utility/jsx";
import { type ReactNode, forwardRef } from "react";

type LabelShellProps = {
  /** Root css class family: `plot-label` (plots, tables, tephigram) or `map-label`. Positioned in overlays/default/style.scss. */
  variant: "plot" | "map";
  dataTestId: string;
  loadingTestId: string;
  isLoading?: boolean;
  /** The items of the main row (title, chips). */
  children: ReactNode;
  /** Content below the main row, still inside the label frame. */
  footer?: ReactNode;
  /** Popovers. Rendered as siblings of the label (not inside), because they are positioned relative to the overlay. */
  popover?: ReactNode;
};

export const LabelShell = forwardRef<HTMLDivElement, LabelShellProps>(function LabelShell(
  { variant, dataTestId, loadingTestId, isLoading, children, footer, popover },
  ref,
) {
  const { showHeader } = useOverlay();
  const rootClass = `${variant}-label`;

  return (
    <>
      <LoadingLabelFrame
        dataTestId={dataTestId}
        loadingTestId={loadingTestId}
        className={classNames(rootClass, showHeader ? `${rootClass}--header-expanded` : "")}
        ref={ref}
        isLoading={isLoading}
      >
        <div className={styles["label-row"]}>{children}</div>
        {footer}
      </LoadingLabelFrame>
      {popover}
    </>
  );
});
